import { getDataConsentTypeForProject, isConsentDataSensitivityScopeValidForConsent } from "healthex-common/consent.dtos";
import { ConsentDataResourceScope, ConsentDataSensitivityScope } from "healthex-common/consentscopes.dtos";
import { defaultReturnButtonLabel } from "healthex-common/project.data";
import { ProjectFieldRequirement, ProjectFieldType, ProjectKey, } from "healthex-common/project.data.dtos";
import { filterIncludeFields, getProjectData, getProjectDataForStudy } from "healthex-common/project.data.utils";
import { ProjectType, StudyAccessData, StudyPeriodicDayAndWeekUnits, StudyPeriodicUnit, StudyTranslationLanguage, StudyType, StudyVersionStatus, } from "healthex-common/study.dtos";
import { enumValues, isKeyOfObject } from "healthex-common/utils";
export const purposeOfDisclosureChoices = [
    "Care coordination",
    "Population health management",
    "Outcome tracking and quality tracking",
    "Prior authorization",
    "Other",
];
const skippedSpecialFields = [
    "additionalInformationTitle",
    "additionalInformationDescription",
    "dataScopes",
    "timelineVisits",
];
export function emptyGlobalAdminProjectFormInput(organizationName) {
    return {
        additionalQuestions: [],
        removedAdditionalQuestionIds: [],
        title: "",
        ownerId: "",
        projectType: ProjectType.AI_DATA_USE,
        aiToolName: "",
        patientFriendlyTitle: "",
        aiChatbotUrl: "",
        aiSharingUrl: "",
        hipaaOrganizationLegalName: organizationName,
        hipaaOrganizationLegalNameConfirmed: false,
        description: "",
        protocolNumber: "",
        suppressNotifications: false,
        suppressHealthexNudges: false,
        patientRecordRetrievalRecencyEnabled: false,
        patientRecordRetrievalRecencyEvery: "30",
        patientRecordRetrievalRecencyUnit: StudyPeriodicUnit.DAY,
        hostedRedirectUrls: "",
        returnToPartnerLabel: defaultReturnButtonLabel(ProjectType.AI_DATA_USE, organizationName),
        healthRecordsUpdatesEnabled: false,
        healthRecordsUpdatesOnDemand: false,
        healthRecordsUpdatesEvery: "",
        healthRecordsUpdatesUnit: StudyPeriodicDayAndWeekUnits.DAY,
        welcomeTitle: "",
        welcomeText: "",
        dataUpdateWelcomeTitle: "",
        dataUpdateWelcomeText: "",
        purposeOfDataBriefEducation: "",
        purposeOfDataDisclosure: [],
        purposeOfDataDisclosureOther: "",
        healthRecordUpdatesText: "",
        sitePrimaryContactName: "",
        sitePrimaryContactTitle: "",
        sitePrimaryContactEmail: "",
        sitePrimaryContactPhone: "",
        sitePrimaryContactPhoneExt: "",
        sitePrimaryContactLink: "",
        contactDetails: "",
        informedConsentStatement: "",
        thankYouConsentedTitle: "",
        thankYouConsentedText: "",
        dataUpdateThankYouConsentedTitle: "",
        dataUpdateThankYouConsentedText: "",
        thankYouDeclinedTitle: "",
        thankYouDeclinedText: "",
        organizationIconUrl: "",
        organizationRectangularIconUrl: "",
    };
}
export function globalAdminProjectFormInputFromStudy(study, organizationName) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20;
    const empty = emptyGlobalAdminProjectFormInput(organizationName);
    const aiToolName = (_a = study.aiToolName) !== null && _a !== void 0 ? _a : "";
    return {
        ...empty,
        additionalQuestions: ((_b = study.additionalSections) !== null && _b !== void 0 ? _b : [])
            .filter((section) => section.language === StudyTranslationLanguage.en)
            .map((section) => ({ id: section.id, title: section.title, description: section.description })),
        removedAdditionalQuestionIds: [],
        title: (_c = study.title) !== null && _c !== void 0 ? _c : "",
        projectType: (_d = study.projectType) !== null && _d !== void 0 ? _d : ProjectType.GENERAL_DATA_USE,
        aiToolName,
        patientFriendlyTitle: (_e = study.patientFriendlyTitle) !== null && _e !== void 0 ? _e : "",
        aiChatbotUrl: (_f = study.aiChatbotUrl) !== null && _f !== void 0 ? _f : "",
        aiSharingUrl: (_g = study.aiSharingUrl) !== null && _g !== void 0 ? _g : "",
        hipaaOrganizationLegalName: (_h = study.hipaaOrganizationLegalName) !== null && _h !== void 0 ? _h : organizationName,
        hipaaOrganizationLegalNameConfirmed: (_j = study.hipaaOrganizationLegalNameConfirmed) !== null && _j !== void 0 ? _j : false,
        description: (_k = study.description) !== null && _k !== void 0 ? _k : "",
        protocolNumber: (_l = study.protocolNumber) !== null && _l !== void 0 ? _l : "",
        suppressNotifications: (_m = study.suppressNotifications) !== null && _m !== void 0 ? _m : false,
        suppressHealthexNudges: (_o = study.suppressHealthexNudges) !== null && _o !== void 0 ? _o : false,
        patientRecordRetrievalRecencyEnabled: (_p = study.patientRecordRetrievalRecencyEnabled) !== null && _p !== void 0 ? _p : false,
        patientRecordRetrievalRecencyEvery: study.patientRecordRetrievalRecencyEvery === undefined || study.patientRecordRetrievalRecencyEvery === null
            ? "30"
            : String(study.patientRecordRetrievalRecencyEvery),
        patientRecordRetrievalRecencyUnit: (_q = study.patientRecordRetrievalRecencyUnit) !== null && _q !== void 0 ? _q : StudyPeriodicUnit.DAY,
        hostedRedirectUrls: (_s = (_r = study.hostedRedirectUrls) === null || _r === void 0 ? void 0 : _r.join(", ")) !== null && _s !== void 0 ? _s : "",
        returnToPartnerLabel: (_t = study.returnToPartnerLabel) !== null && _t !== void 0 ? _t : defaultReturnButtonLabel(study.projectType, organizationName),
        healthRecordsUpdatesEnabled: (_u = study.healthRecordsUpdatesEnabled) !== null && _u !== void 0 ? _u : false,
        healthRecordsUpdatesOnDemand: (_v = study.healthRecordsUpdatesOnDemand) !== null && _v !== void 0 ? _v : false,
        healthRecordsUpdatesEvery: study.healthRecordsUpdatesEvery === undefined || study.healthRecordsUpdatesEvery === null
            ? ""
            : String(study.healthRecordsUpdatesEvery),
        healthRecordsUpdatesUnit: (_w = study.healthRecordsUpdatesUnit) !== null && _w !== void 0 ? _w : StudyPeriodicDayAndWeekUnits.DAY,
        welcomeTitle: (_x = study.welcomeTitle) !== null && _x !== void 0 ? _x : "",
        welcomeText: (_y = study.welcomeText) !== null && _y !== void 0 ? _y : "",
        dataUpdateWelcomeTitle: (_z = study.dataUpdateWelcomeTitle) !== null && _z !== void 0 ? _z : "",
        dataUpdateWelcomeText: (_0 = study.dataUpdateWelcomeText) !== null && _0 !== void 0 ? _0 : "",
        purposeOfDataBriefEducation: (_1 = study.purposeOfDataBriefEducation) !== null && _1 !== void 0 ? _1 : "",
        purposeOfDataDisclosure: (_2 = study.purposeOfDataDisclosure) !== null && _2 !== void 0 ? _2 : [],
        purposeOfDataDisclosureOther: (_3 = study.purposeOfDataDisclosureOther) !== null && _3 !== void 0 ? _3 : "",
        healthRecordUpdatesText: (_4 = study.healthRecordUpdatesText) !== null && _4 !== void 0 ? _4 : "",
        sitePrimaryContactName: (_5 = study.sitePrimaryContactName) !== null && _5 !== void 0 ? _5 : "",
        sitePrimaryContactTitle: (_6 = study.sitePrimaryContactTitle) !== null && _6 !== void 0 ? _6 : "",
        sitePrimaryContactEmail: (_7 = study.sitePrimaryContactEmail) !== null && _7 !== void 0 ? _7 : "",
        sitePrimaryContactPhone: (_8 = study.sitePrimaryContactPhone) !== null && _8 !== void 0 ? _8 : "",
        sitePrimaryContactPhoneExt: (_9 = study.sitePrimaryContactPhoneExt) !== null && _9 !== void 0 ? _9 : "",
        sitePrimaryContactLink: (_10 = study.sitePrimaryContactLink) !== null && _10 !== void 0 ? _10 : "",
        contactDetails: (_11 = study.contactDetails) !== null && _11 !== void 0 ? _11 : "",
        informedConsentStatement: (_12 = study.informedConsentStatement) !== null && _12 !== void 0 ? _12 : "",
        thankYouConsentedTitle: (_13 = study.thankYouConsentedTitle) !== null && _13 !== void 0 ? _13 : "",
        thankYouConsentedText: (_14 = study.thankYouConsentedText) !== null && _14 !== void 0 ? _14 : "",
        dataUpdateThankYouConsentedTitle: (_15 = study.dataUpdateThankYouConsentedTitle) !== null && _15 !== void 0 ? _15 : "",
        dataUpdateThankYouConsentedText: (_16 = study.dataUpdateThankYouConsentedText) !== null && _16 !== void 0 ? _16 : "",
        thankYouDeclinedTitle: (_17 = study.thankYouDeclinedTitle) !== null && _17 !== void 0 ? _17 : "",
        thankYouDeclinedText: (_18 = study.thankYouDeclinedText) !== null && _18 !== void 0 ? _18 : "",
        organizationIconUrl: (_19 = study.organizationIconUrl) !== null && _19 !== void 0 ? _19 : "",
        organizationRectangularIconUrl: (_20 = study.organizationRectangularIconUrl) !== null && _20 !== void 0 ? _20 : "",
    };
}
export function toCreateStudyInput(input, ownerId, isPdda) {
    const fields = toPersistedStudyFields(input, isPdda);
    return {
        ownerId,
        studyType: StudyType.OTHER,
        require21CFRPart11ForInformedConsents: false,
        informedConsentSectionLocked: false,
        accessData: StudyAccessData.FULL_RECORD_IDENTIFIED,
        isSponsor: false,
        consentDataResourceScopes: enumValues(ConsentDataResourceScope),
        consentDataSensitivityScopes: defaultSensitivityScopes(isPdda),
        fullRecordWithoutRestrictedData: true,
        ...fields,
    };
}
export function toUpdateStudyVersionInput(input, isPdda, publish, versionName) {
    const fields = toPersistedStudyFields(input, isPdda);
    return {
        ...fields,
        additionalSections: toAdditionalSectionsUpdate(input),
        ...(isPdda
            ? {
                accessData: StudyAccessData.FULL_RECORD_IDENTIFIED,
                consentDataResourceScopes: enumValues(ConsentDataResourceScope),
                consentDataSensitivityScopes: defaultSensitivityScopes(true),
            }
            : {}),
        ...(publish
            ? {
                versionStatus: StudyVersionStatus.ACTIVE,
                versionName: versionName !== null && versionName !== void 0 ? versionName : "v1",
            }
            : {}),
    };
}
function toAdditionalSectionsUpdate(input) {
    return [
        ...input.additionalQuestions.map((question) => ({
            ...(question.id === null ? {} : { id: question.id }),
            title: question.title.trim(),
            description: question.description.trim(),
            included: true,
        })),
        ...input.removedAdditionalQuestionIds.map((id) => ({ id, delete: true })),
    ];
}
export function additionalQuestionsIncomplete(input) {
    return input.additionalQuestions.some((question) => question.title.trim() === "" || question.description.trim() === "");
}
export function catalogPagesForForm(input) {
    const pages = getProjectDataForStudy(getProjectData(ProjectKey.GENERALDATAUSE_IDENTIFIED_PDDE)).pages;
    return pages
        .map((page) => ({
        ...page,
        sections: page.sections
            .map((section) => ({
            ...section,
            fields: filterIncludeFields(input, section.fields).filter((field) => shouldShowCatalogField(field, input)),
        }))
            .filter((section) => section.fields.length > 0),
    }))
        .filter((page) => page.sections.length > 0);
}
export function isStringFormField(fieldName, input) {
    return isKeyOfObject(fieldName, input) && typeof input[fieldName] === "string";
}
export function isBooleanFormField(fieldName, input) {
    return isKeyOfObject(fieldName, input) && typeof input[fieldName] === "boolean";
}
export const projectBasicsFieldNames = [
    "title",
    "ownerId",
    "aiToolName",
    "aiChatbotUrl",
    "aiSharingUrl",
    "hipaaOrganizationLegalName",
    "hipaaOrganizationLegalNameConfirmed",
];
export function catalogFieldHasValidationError(field, errors) {
    if (field.fieldName && isKeyOfObject(field.fieldName, errors) && errors[field.fieldName]) {
        return true;
    }
    if (field.specialFieldName === "purposeOfDataDisclosure" && errors.purposeOfDataDisclosure) {
        return true;
    }
    if (field.specialFieldName === "sitePrimaryContactPhoneNumber" &&
        (hasContactMethodFormError(errors) || errors.sitePrimaryContactPhone)) {
        return true;
    }
    if (field.specialFieldName === "healthRecordUpdates" && errors.healthRecordsUpdatesEvery) {
        return true;
    }
    if (field.specialFieldName === "patientRecordRetrievalRecency" && errors.patientRecordRetrievalRecencyEvery) {
        return true;
    }
    if (field.specialFieldName === "additionalQuestions" && errors.additionalQuestions) {
        return true;
    }
    if (field.specialFieldName === "organizationIcon" && errors.organizationIconUrl) {
        return true;
    }
    if (field.specialFieldName === "organizationRectangularIcon" && errors.organizationRectangularIconUrl) {
        return true;
    }
    return false;
}
export function firstValidationErrorPage(input, errors, basicsPageName) {
    if (projectBasicsFieldNames.some((fieldName) => errors[fieldName])) {
        return basicsPageName;
    }
    for (const page of catalogPagesForForm(input)) {
        for (const section of page.sections) {
            for (const field of section.fields) {
                if (catalogFieldHasValidationError(field, errors)) {
                    return page.pageName;
                }
            }
        }
    }
    return null;
}
export function catalogFieldExceedsCharacterLimit(field, input) {
    if (!field.fieldName || typeof field.characterLimit !== "number") {
        return false;
    }
    if (!isStringFormField(field.fieldName, input)) {
        return false;
    }
    return input[field.fieldName].length > field.characterLimit;
}
export function catalogFieldMissing(field, input) {
    if (field.fieldRequirement !== ProjectFieldRequirement.REQUIRED) {
        return false;
    }
    if (field.fieldName === "title") {
        return false;
    }
    if (field.fieldName && isStringFormField(field.fieldName, input)) {
        if (isContactMethodChoiceFieldName(field.fieldName)) {
            return !hasContactMethod(input);
        }
        if (!input[field.fieldName].trim()) {
            return true;
        }
        return catalogFieldExceedsCharacterLimit(field, input);
    }
    if (field.specialFieldName === "purposeOfDataDisclosure") {
        if (input.projectType === ProjectType.AI_DATA_USE) {
            return false;
        }
        if (input.purposeOfDataDisclosure.length === 0) {
            return true;
        }
        return input.purposeOfDataDisclosure.includes("Other") && input.purposeOfDataDisclosureOther.trim() === "";
    }
    if (field.specialFieldName === "sitePrimaryContactPhoneNumber") {
        return !hasContactMethod(input);
    }
    if (field.specialFieldName === "healthRecordUpdates") {
        if (!input.healthRecordsUpdatesEnabled) {
            return false;
        }
        if (input.healthRecordsUpdatesOnDemand) {
            return false;
        }
        return parsePositiveInt(input.healthRecordsUpdatesEvery) === undefined;
    }
    if (field.specialFieldName === "additionalQuestions") {
        return additionalQuestionsIncomplete(input);
    }
    if (field.specialFieldName === "organizationIcon") {
        return input.organizationIconUrl.trim() === "";
    }
    if (field.specialFieldName === "organizationRectangularIcon") {
        return input.organizationRectangularIconUrl.trim() === "";
    }
    if (field.specialFieldName === "patientRecordRetrievalRecency") {
        if (!input.patientRecordRetrievalRecencyEnabled) {
            return false;
        }
        return parsePositiveInt(input.patientRecordRetrievalRecencyEvery) === undefined;
    }
    return false;
}
function shouldShowCatalogField(field, input) {
    if (field.viewOnlyFieldName !== undefined ||
        field.viewOnlySpecialCaseFieldName !== undefined ||
        field.fieldSectionAddImageName !== undefined) {
        return false;
    }
    if (field.fieldType === ProjectFieldType.SUBSECTION_END) {
        return false;
    }
    if (field.fieldName === "title") {
        return false;
    }
    if (input.projectType === ProjectType.AI_DATA_USE && field.specialFieldName === "purposeOfDataDisclosure") {
        return false;
    }
    if (field.specialFieldName && skippedSpecialFields.includes(field.specialFieldName)) {
        return false;
    }
    return true;
}
export function isContactMethodChoiceFieldName(fieldName) {
    return fieldName === "sitePrimaryContactEmail" || fieldName === "sitePrimaryContactLink";
}
export const contactMethodRequiredMessage = "At least one of email, phone, or link is required.";
export function hasContactMethodFormError(errors) {
    return errors.sitePrimaryContactEmail === contactMethodRequiredMessage;
}
function hasContactMethod(input) {
    return (input.sitePrimaryContactEmail.trim() !== "" ||
        input.sitePrimaryContactPhone.trim() !== "" ||
        input.sitePrimaryContactLink.trim() !== "");
}
function defaultSensitivityScopes(isPdda) {
    if (!isPdda) {
        return [ConsentDataSensitivityScope.NORMAL];
    }
    return enumValues(ConsentDataSensitivityScope).filter((scope) => isConsentDataSensitivityScopeValidForConsent(getDataConsentTypeForProject({ pdda: true }), scope));
}
function toPersistedStudyFields(input, isPdda) {
    const isAIProject = input.projectType === ProjectType.AI_DATA_USE;
    const organizationName = input.hipaaOrganizationLegalName;
    const defaultLabel = defaultReturnButtonLabel(input.projectType, organizationName);
    return {
        title: input.title,
        projectType: input.projectType,
        description: emptyToNull(input.description),
        protocolNumber: emptyToNull(input.protocolNumber),
        suppressNotifications: input.suppressNotifications,
        suppressHealthexNudges: isAIProject ? false : input.suppressHealthexNudges,
        patientRecordRetrievalRecencyEnabled: input.patientRecordRetrievalRecencyEnabled,
        patientRecordRetrievalRecencyEvery: input.patientRecordRetrievalRecencyEnabled
            ? parsePositiveInt(input.patientRecordRetrievalRecencyEvery)
            : undefined,
        patientRecordRetrievalRecencyUnit: input.patientRecordRetrievalRecencyEnabled ? input.patientRecordRetrievalRecencyUnit : undefined,
        hostedRedirectUrls: splitRedirectUrls(input.hostedRedirectUrls),
        returnToPartnerLabel: input.returnToPartnerLabel.trim() === "" || input.returnToPartnerLabel === defaultLabel ? null : input.returnToPartnerLabel,
        healthRecordsUpdatesEnabled: input.healthRecordsUpdatesEnabled,
        healthRecordsUpdatesOnDemand: input.healthRecordsUpdatesEnabled ? input.healthRecordsUpdatesOnDemand : undefined,
        healthRecordsUpdatesEvery: input.healthRecordsUpdatesEnabled && !input.healthRecordsUpdatesOnDemand
            ? parsePositiveInt(input.healthRecordsUpdatesEvery)
            : undefined,
        healthRecordsUpdatesUnit: input.healthRecordsUpdatesEnabled && !input.healthRecordsUpdatesOnDemand ? input.healthRecordsUpdatesUnit : undefined,
        welcomeTitle: emptyToNull(input.welcomeTitle),
        welcomeText: emptyToNull(input.welcomeText),
        dataUpdateWelcomeTitle: emptyToNull(input.dataUpdateWelcomeTitle),
        dataUpdateWelcomeText: emptyToNull(input.dataUpdateWelcomeText),
        purposeOfDataBriefEducation: emptyToNull(input.purposeOfDataBriefEducation),
        purposeOfDataDisclosure: input.purposeOfDataDisclosure,
        purposeOfDataDisclosureOther: input.purposeOfDataDisclosure.includes("Other")
            ? emptyToNull(input.purposeOfDataDisclosureOther)
            : null,
        patientFriendlyTitle: emptyToNull(input.patientFriendlyTitle),
        healthRecordUpdatesText: emptyToNull(input.healthRecordUpdatesText),
        sitePrimaryContactName: emptyToNull(input.sitePrimaryContactName),
        sitePrimaryContactTitle: emptyToNull(input.sitePrimaryContactTitle),
        sitePrimaryContactEmail: emptyToNull(input.sitePrimaryContactEmail),
        sitePrimaryContactPhone: emptyToNull(input.sitePrimaryContactPhone),
        sitePrimaryContactPhoneExt: emptyToNull(input.sitePrimaryContactPhoneExt),
        sitePrimaryContactLink: emptyToNull(input.sitePrimaryContactLink),
        contactDetails: emptyToNull(input.contactDetails),
        informedConsentStatement: emptyToNull(input.informedConsentStatement),
        thankYouConsentedTitle: emptyToNull(input.thankYouConsentedTitle),
        thankYouConsentedText: emptyToNull(input.thankYouConsentedText),
        dataUpdateThankYouConsentedTitle: emptyToNull(input.dataUpdateThankYouConsentedTitle),
        dataUpdateThankYouConsentedText: emptyToNull(input.dataUpdateThankYouConsentedText),
        thankYouDeclinedTitle: emptyToNull(input.thankYouDeclinedTitle),
        thankYouDeclinedText: emptyToNull(input.thankYouDeclinedText),
        organizationIconUrl: emptyToNull(input.organizationIconUrl),
        organizationRectangularIconUrl: emptyToNull(input.organizationRectangularIconUrl),
        hipaaOrganizationLegalName: isPdda || isAIProject ? input.hipaaOrganizationLegalName : undefined,
        hipaaOrganizationLegalNameConfirmed: isPdda ? input.hipaaOrganizationLegalNameConfirmed : undefined,
        aiToolName: isAIProject ? emptyToNull(input.aiToolName) : undefined,
        aiChatbotUrl: isAIProject ? emptyToNull(input.aiChatbotUrl) : undefined,
        aiSharingUrl: isAIProject ? emptyToNull(input.aiSharingUrl) : undefined,
    };
}
function emptyToNull(value) {
    return value.trim() === "" ? null : value;
}
function splitRedirectUrls(value) {
    return value
        .split(",")
        .map((url) => url.trim())
        .filter((url) => url.length > 0);
}
function parsePositiveInt(value) {
    const parsed = parseInt(value, 10);
    if (Number.isNaN(parsed) || parsed < 1) {
        return undefined;
    }
    return parsed;
}
